<template>
  <div class="export-btn">
    <button
      class="s-btn btn-blue is-plain btn-xs"
      :class="[ classList ]"
      :disabled="disabled || loading"
      @click="exportData"
    >
      <i v-show="loading" class="el-icon-loading"></i>{{ text || '下载Excel' }}
    </button>
  </div>
</template>

<script>
import exportService from '@/services/export-service';
import moment from 'moment';
import { Message } from 'element-ui';

export default {
  props: {
    disabled: Boolean,
    text: {
      type: String,
      default: '',
    },
    classNameList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false, 
    };
  },
  computed: {
    classList() {
      return this.classNameList.join(',');
    },
  },
  methods: {
    async exportData() {   
      try {
        this.loading = true;
        this.$emit('exportFn', (exportData, exportHeader, fileNmae) => {
          if (!exportData || !exportData.length) {
            exportData && Message.warning({
              message: '无数据可导出',
            });
            this.loading = false;
            return;
          }

          // 数据导出
          exportService.exportIntoXLSXByJson(
            exportData || [],
            exportHeader || {},
            fileNmae || `${moment(new Date()).format('YYYYMMDDHHmmss')}.xlsx`,
          );
          this.loading = false;
        });
      } catch (e) {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.export-btn {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/common/export-btn.vue